import noPermissionImg from "assets/permission.png";
const LayoutView: React.FC = () => {
  return (
    <div
      style={{
        position: "relative",
           height: "calc(100vh - 92px)",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* ====== Center Card ====== */}
      <div
        style={{
          textAlign: "center",
          background: "white",
          padding: "20px",
          borderRadius: 16,
          boxShadow: "0px 8px 25px rgba(0,0,0,0.12)",
          zIndex: 10,
          width: 400,
        }}
      >
        <img
          src={noPermissionImg}
          alt="No Permission"
          style={{ width: 100, marginBottom: 5 }}
        />

        <h2 style={{ marginBottom: 10, color: "#111", fontSize: 26 }}>
          No Permission
        </h2>

        <p
          style={{
            color: "#666",
            fontSize: 16,
            maxWidth: 350,
            margin: "0 auto 25px",
            lineHeight: 1.5,
          }}
        >
          You do not have permission to access this page.
          Please contact admin to enable permissions.
        </p>

        
      </div>
    </div>
  );
};

export default LayoutView;
